/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { FC, useState, useEffect } from "react";
import Label from "components/Label";
import { HiOutlineCheck as CheckIcon } from "react-icons/hi";

import text from "constants/text";
import Button from "components/Button";
import { useRouter } from "next/router";
import segment from "lib/segment";
import { getQueryString } from "utils/url";
import WhatYouGet from "pages/homeowners/components/WhatYouGet";
import YourMembership from "pages/homepage/components/YourMembership";
import TheDifference from "pages/homepage/components/TheDifference";
import styles from "./styles.module.scss";
import Shape from "../../../../../public/shape-5.svg";

interface Props {
  plan: "BASIC" | "PRO" | "DISCOUNT";
  variant?: "INSPECTION" | "URL_DERIVED" | "PRO_REFERRAL";
}

const INCLUDES = [
  "❗ 24/7 Emergency Support for urgent repairs, leaks, heating issues and more",
  "🔨 Instant booking for HVAC, Handyman Electrical, and Plumbing jobs",
  "🗓️ Same-day or next-day availability with vetted service providers",
  "📱 Unlimited expert advice for bids, cost estimates, renovation planning and more",
  "🏠 Personalized Maintenance Plans to track, remind & book service pros"
];

const PaymentPlan: FC<Props> = ({ plan, variant }) => {
  const { subscriptions } = { ...text.onboarding };
  const { maintenance_plan: maintenancePlan } = text.our_membership;

  const router = useRouter();

  useEffect(() => {
    segment.track("Survey Started", { location: "Lead form", ...router.query });
  }, []);

  const [selectedSubscription, setSelectedSubscription] = useState<string>(
    process.env.NEXT_PUBLIC_SUB_BASIC_PRICE_MONTH || ""
  );

  const subs = plan
    ? subscriptions[plan as "PRO" | "BASIC" | "DISCOUNT"] || subscriptions.BASIC
    : subscriptions.BASIC;

  useEffect(() => {
    if (plan) {
      setSelectedSubscription(plan);
    }
  }, [plan]);

  useEffect(() => {
    setSelectedSubscription(subs[0].id || "");
  }, [subs]);

  const setSubscription = (id: string) => {
    setSelectedSubscription(id);
  };

  const confirmPaymentPlan = () => {
    segment.track("Payment Plan Selected", router.query);
    router.push(
      `${router.pathname}?${getQueryString({
        ...router.query,
        pid: selectedSubscription
      })}`
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.pageHeader}>
          <Label variant="h-centered" color="white" className={styles.title}>
            {variant && variant === "PRO_REFERRAL"
              ? "You qualify for an additional discount from your local Pro!"
              : "Your Digital Home Manager Has Arrived."}
          </Label>
        </div>

        <div className={styles.content}>
          <div className={styles.leftPanel}>
            <Shape className={styles.shape} />

            <div className={styles.membership}>
              <Label className={styles.membershipHeadline} variant="s">
                {variant && variant === "PRO_REFERRAL"
                  ? "We’re building a community of only the best Service Pros. Use your Pro’s code at checkout to receive an extra 25% off your digital Home Manager."
                  : "Humming Homes takes care of emergencies, helps you easily book vetted service pros, provides expert advice and makes maintenance planning easy."}
              </Label>
              <div className={styles.items}>
                {INCLUDES.map((item) => (
                  <div className={styles.item} key={item}>
                    <Label
                      className={styles.itemLabel}
                      variant="s"
                      color="primary"
                    >
                      {item}
                    </Label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={styles.rightPanel}>
            <div className={styles.subscriptions}>
              {subs.map((subscription) => {
                const {
                  id = "",
                  description,
                  original_price: originalPrice,
                  price,
                  subtitle,
                  eyebrow
                } = subscription;
                const isSelected = id === selectedSubscription;

                return (
                  <div
                    className={`${styles.subscription} ${
                      isSelected && styles.selectedSubscription
                    }`}
                    onClick={() => setSubscription(id)}
                    key={id}
                  >
                    <div className={styles.bottom}>
                      <div className={styles.radio}>
                        {isSelected ? (
                          <CheckIcon className={styles.check} />
                        ) : (
                          <div className={styles.circle} />
                        )}
                      </div>
                      {eyebrow && (
                        <Label variant="s" className={styles.eyebrow}>
                          {eyebrow}
                        </Label>
                      )}
                      <Label className={styles.original} variant="h">
                        {originalPrice || ""}
                      </Label>
                      <Label className={styles.price} variant="h">
                        {price}
                      </Label>
                      <Label variant="s" className={styles.description}>
                        {description}
                      </Label>
                      {subtitle && (
                        <Label
                          variant="s-capitalized"
                          className={styles.subtitle}
                        >
                          {subtitle}
                        </Label>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className={styles.actions}>
              {/* <Button
                onClick={confirmPaymentPlan}
                disabled={!selectedSubscription}
                variant="accent"
                className={styles.submit}
              >
                Get Covered Now
              </Button> */}
              {/* <Button variant="accent" className={styles.submit}>
                Get Covered Now
              </Button> */}
            </div>
          </div>
        </div>
      </div>

      <WhatYouGet {...maintenancePlan} />
      <TheDifference />
      <div className={styles.yourMembership}>
        <YourMembership
          onClickGetStarted={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0 });
          }}
        />
      </div>
    </div>
  );
};

export default PaymentPlan;
